module.exports = __webpack_public_path__ + "static/media/icono-3.d3daf32a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/gbadicionales/icono-3.svg
// module id = 751
// module chunks = 0